import clsx from "clsx";
import styled from "styled-components";
import React, { useState, useContext } from "react";
import translationIdle from "./images/Btn/Translate/translationIdle.png";
import translationHover from "./images/Btn/Translate/translationHover.png";
import translationActive from "./images/Btn/Translate/translationActive.png";
import translationActiveHover from "./images/Btn/Translate/translationActiveHover.png";
import { requestTranslation } from "@futures-platform/i18n";
import { DataContext } from "../store/GlobalState";

const TranslationBtn = ({
  // color = '#b0b0b0',
  width = "39px",
  height = "39px",
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = /Mobi/.test(window.navigator.userAgent)
  const { state: { contentData } } = useContext(DataContext);

  return (
    <FlagWrapper
      data-title={contentData?.title}
      data-action-id="voting"
      data-vote-type={"down"}
      data-vote-status={isNewsBookMarked ? "voted" : "not-voted"}
      onMouseOver={() => {
        setIsHover(() => true);
      }}
      onMouseOut={() => {
        setIsHover(() => false);
      }}
      className="vote-down voted-btn"
      id="vote-down"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: "pointer",
      }}
    >
      {!isAuthed ? (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby={requestTranslation("DownvoteSVG")}
          aria-describedby={requestTranslation("DownvoteSVG")}
        >
          <title>{requestTranslation("DownvoteSVG")}</title>
          <mask
            id="mask0_4014_2237"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="36"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4014_2237)">
            <rect width="36" height="36" fill="#E8EBEB" />
            <circle cx="18" cy="18" r="17" fill="white" />
          </g>
          <path
            d="M10.4999 18.5C10.4999 20.4031 11 20.803 12.5 20.8031H16.5L16 25.3031C15.8333 26.8031 17.5 26.8031 18 25.8031L20.9999 20.4031V12.2031C20.9999 12.2031 19.5 11.803 17.5 11.803C15.5 11.803 13.9999 11.803 12.4999 12.5C10.9999 13.197 10.4999 16.5 10.4999 18.5Z"
            fill="#637282"
          />
          <path
            d="M24.4999 12.3031L21.9999 12.2031V20.4031L24.4999 20.3031C25.4996 20.2631 25.4999 20.3031 25.4999 19.3031V13.3031C25.4999 12.3031 25.4991 12.343 24.4999 12.3031Z"
            fill="#637282"
          />
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("DownvoteSVG")}
          aria-describedby={requestTranslation("DownvoteSVG")}
                >
                  <title>{requestTranslation("DownvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2239"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2239)">
                    <rect width="36" height="36" fill="#00C3FF" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M10.4999 18.5C10.4999 20.4031 11 20.803 12.5 20.8031H16.5L16 25.3031C15.8333 26.8031 17.5 26.8031 18 25.8031L20.9999 20.4031V12.2031C20.9999 12.2031 19.5 11.803 17.5 11.803C15.5 11.803 13.9999 11.803 12.4999 12.5C10.9999 13.197 10.4999 16.5 10.4999 18.5Z"
                    fill="#00C3FF"
                  />
                  <path
                    d="M24.4999 12.3031L21.9999 12.2031V20.4031L24.4999 20.3031C25.4996 20.2631 25.4999 20.3031 25.4999 19.3031V13.3031C25.4999 12.3031 25.4991 12.343 24.4999 12.3031Z"
                    fill="#00C3FF"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("DownvoteSVG")}
          aria-describedby={requestTranslation("DownvoteSVG")}
                >
                  <title>{requestTranslation("DownvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2238"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2238)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M10.4999 18.5C10.4999 20.4031 11 20.803 12.5 20.8031H16.5L16 25.3031C15.8333 26.8031 17.5 26.8031 18 25.8031L20.9999 20.4031V12.2031C20.9999 12.2031 19.5 11.803 17.5 11.803C15.5 11.803 13.9999 11.803 12.4999 12.5C10.9999 13.197 10.4999 16.5 10.4999 18.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M24.4999 12.3031L21.9999 12.2031V20.4031L24.4999 20.3031C25.4996 20.2631 25.4999 20.3031 25.4999 19.3031V13.3031C25.4999 12.3031 25.4991 12.343 24.4999 12.3031Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("DownvoteSVG")}
          aria-describedby={requestTranslation("DownvoteSVG")}
                >
                  <title>{requestTranslation("DownvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2237"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2237)">
                    <rect width="36" height="36" fill="#E8EBEB" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M10.4999 18.5C10.4999 20.4031 11 20.803 12.5 20.8031H16.5L16 25.3031C15.8333 26.8031 17.5 26.8031 18 25.8031L20.9999 20.4031V12.2031C20.9999 12.2031 19.5 11.803 17.5 11.803C15.5 11.803 13.9999 11.803 12.4999 12.5C10.9999 13.197 10.4999 16.5 10.4999 18.5Z"
                    fill="#637282"
                  />
                  <path
                    d="M24.4999 12.3031L21.9999 12.2031V20.4031L24.4999 20.3031C25.4996 20.2631 25.4999 20.3031 25.4999 19.3031V13.3031C25.4999 12.3031 25.4991 12.343 24.4999 12.3031Z"
                    fill="#637282"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("DownvoteSVG")}
          aria-describedby={requestTranslation("DownvoteSVG")}
                >
                  <title>{requestTranslation("DownvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2238"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2238)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M10.4999 18.5C10.4999 20.4031 11 20.803 12.5 20.8031H16.5L16 25.3031C15.8333 26.8031 17.5 26.8031 18 25.8031L20.9999 20.4031V12.2031C20.9999 12.2031 19.5 11.803 17.5 11.803C15.5 11.803 13.9999 11.803 12.4999 12.5C10.9999 13.197 10.4999 16.5 10.4999 18.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M24.4999 12.3031L21.9999 12.2031V20.4031L24.4999 20.3031C25.4996 20.2631 25.4999 20.3031 25.4999 19.3031V13.3031C25.4999 12.3031 25.4991 12.343 24.4999 12.3031Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  );
};

export default TranslationBtn;

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`;

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`;
